var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-divider',{staticClass:"operation-divider m-0",attrs:{"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }